module.exports = __webpack_public_path__ + "img/NX_Step_4.64974cc4.png";